import { Document, Page, StyleSheet } from "@react-pdf/renderer";
import PDFPageHeader from "components/datapdf/PDFPageHeader";

const PDFExport = (props) => {
  const { children, useHeader = true, title = "PDF-Export", pageStyle = {}, ...rest } = props;
  const styles = StyleSheet.create({
    page: {
      fontSize: 9,
      flexDirection: "column",
      backgroundColor: "#FFFFFF",
      padding: 40,
    },
  });

  return (
    <Document title={title}>
      <Page style={[styles.page, pageStyle]} {...rest}>
        {useHeader && <PDFPageHeader {...rest} />}
        {children}
      </Page>
    </Document>
  );
};

PDFExport.defaultProps = {
  size: "A4",
  orientation: "portrait",
};

export default PDFExport;
